module.exports = __webpack_public_path__ + "img/deutz@2x.298273ff.png";